module.exports = __webpack_public_path__ + "static/media/pic4.ba8075af.jpg";